import { inject, Injectable } from '@angular/core';
import { SharePayLoadInterface } from '@interfaces/share/share-playLoad-interface';
import { SharePlatform } from '../../../shared/types/share-platform-type';
import { ClipBoardService } from '@core/services/clipBoard/clip-board.service';
import { environment } from '../../../../environments/environment';
import { MenuActions } from '../../../shared/states/menu_actions';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  private clipboard = inject(ClipBoardService);
  private menuActions = inject(MenuActions);
  async nativeShare(payload: SharePayLoadInterface) {
    if (navigator.share) {
      try {
        await navigator.share({ title: payload.title, text: payload.text, url: payload.url });
        return true;
      } catch {
        return false;
      }
    }
    return false;
  }

  open(platform: SharePlatform, payload: SharePayLoadInterface) {
    const u = encodeURIComponent(payload.url);
    const t = encodeURIComponent(`${payload.title} — ${payload.text}`);
    const whatsappUrl = environment.shareURL.WHATSAPP;
    const facebookUrl = environment.shareURL.FACEBOOK;
    const linkedinUrl = environment.shareURL.LINKEDIN;
    let href = '';
    switch (platform) {
      case 'whatsapp':
        href = `${whatsappUrl}${t}%0A${u}`;
        break;
      case 'facebook':
        href = `${facebookUrl}${u}`;
        break;
      case 'linkedin':
        href = `${linkedinUrl}${u}`;
        break;
      default:
        return;
    }
    this.menuActions.navigateToURL(href);
  }

  copyToClipboard(text: string) {
    return this.clipboard.copy(text)?.then();
  }
}
